import { t } from "@/lib/i18n";

// Демо-данные окна «Каталог каналов» для главной Hub.
// kind: qr — подключение по QR (WhatsApp), token — по токену (Telegram-бот), oauth — авторизация в сервисе, code — вебхук/API.

export const channelCategories = [
  { id: "all", label: t("Все каналы"), icon: "ri-apps-2-line" },
  { id: "messengers", label: t("Мессенджеры"), icon: "ri-chat-3-line" },
  { id: "calls", label: t("Звонки"), icon: "ri-phone-line" },
  { id: "sms", label: "SMS", icon: "ri-message-2-line" },
  { id: "email", label: t("Почта"), icon: "ri-mail-line" },
  { id: "chat", label: t("Онлайн-чат"), icon: "ri-customer-service-2-line" },
  { id: "api", label: t("API и вебхуки"), icon: "ri-plug-line" },
];

export const channelCatalog = [
  {
    id: "whatsapp",
    name: "WhatsApp",
    description: t("Два типа аккаунта: обычный — по QR-коду или номеру телефона, официальный WABA — для рассылок."),
    category: "messengers",
    icon: "ri-whatsapp-line",
    badge: t("2 типа"),
    kind: "qr",
    family: "whatsapp",
    connected: false,
    account: "",
    steps: [
      t("Выберите тип аккаунта: обычный WhatsApp или WABA"),
      t("Войдите по QR-коду либо по номеру телефона"),
      t("Для WABA укажите Phone number ID и токен доступа"),
    ],
  },
  {
    id: "telegram",
    name: "Telegram",
    description: t("Два варианта: любой аккаунт — по QR-коду (пишем первым) или бот по токену от @BotFather."),
    category: "messengers",
    icon: "ri-telegram-line",
    badge: t("2 типа"),
    kind: "qr",
    family: "telegram",
    connected: false,
    account: "",
    steps: [
      t("Выберите вариант: аккаунт Telegram или Telegram Bot"),
      t("Аккаунт — Настройки → Устройства → Подключить устройство"),
      t("Бот — вставьте токен от @BotFather"),
    ],
  },
  {
    id: "instagram",
    name: "Instagram Direct",
    description: t("Два пути: вход прямо в аккаунт по логину и коду либо подключение бизнес-страницы через Facebook."),
    category: "messengers",
    icon: "ri-instagram-line",
    badge: t("2 типа"),
    kind: "oauth",
    family: "instagram",
    connected: false,
    account: "",
    steps: [
      t("Выберите способ: аккаунт Instagram или бизнес-страница Facebook"),
      t("Войдите по логину и коду 2FA либо выберите страницу в Meta"),
      t("Разрешите доступ к сообщениям — диалоги пойдут во «Входящие»"),
    ],
  },
  {
    id: "facebook",
    name: "Facebook Messenger",
    description: t("Сообщения со страницы компании в том же окне, что и остальные каналы."),
    category: "messengers",
    icon: "ri-facebook-circle-line",
    kind: "oauth",
    connected: false,
    account: "",
    steps: [
      t("Выберите бизнес-страницу Facebook"),
      t("Подтвердите доступ к сообщениям"),
      t("Назначьте ответственных продавцов"),
    ],
  },
  {
    id: "viber",
    name: "Viber",
    description: t("Два варианта: любой аккаунт по QR-коду с PIN либо официальный Viber Business по токену."),
    category: "messengers",
    icon: "ri-phone-line",
    badge: t("2 типа"),
    kind: "qr",
    family: "viber",
    connected: false,
    account: "",
    steps: [
      t("Выберите вариант: аккаунт Viber или Viber Business"),
      t("Аккаунт — сканируйте QR-код или введите PIN на телефоне"),
      t("Viber Business — вставьте токен из кабинета и проверьте соединение"),
    ],
  },
  {
    id: "avito",
    name: t("Avito Сообщения"),
    description: t("Сообщения по объявлениям и заявки с Avito — рядом с WhatsApp и Telegram."),
    category: "messengers",
    icon: "ri-store-2-line",
    kind: "oauth",
    connected: false,
    account: "",
    steps: [t("Войдите в аккаунт Avito"), t("Выберите магазин или профиль"), t("Разрешите доступ к переписке")],
  },
  {
    id: "telephony",
    name: t("Телефония и звонки"),
    description: t("Входящие звонки, запись разговоров и карточка клиента в ленте."),
    category: "calls",
    icon: "ri-phone-line",
    kind: "token",
    connected: false,
    account: "",
    steps: [t("Укажите номер АТС и SIP-пароль"), t("Проверьте входящую линию"), t("Включите запись разговоров")],
  },
  {
    id: "sms",
    name: t("SMS-шлюз"),
    description: t("Короткие уведомления и подтверждения, когда клиент не в мессенджере."),
    category: "sms",
    icon: "ri-message-2-line",
    kind: "token",
    connected: false,
    account: "",
    steps: [t("Вставьте API-ключ шлюза"), t("Укажите имя отправителя"), t("Сохраните и отправьте тест")],
  },
  {
    id: "email",
    name: t("Почта (Gmail Workspace)"),
    description: t("Письма клиентов превращаются в диалоги с историей и вложениями — ящик сотрудника подключается по адресу."),
    category: "email",
    icon: "ri-mail-line",
    kind: "token",
    connected: false,
    account: "",
    steps: [t("Выберите сотрудника и его адрес"), t("Hub проверит доступ к ящику"), t("История писем подтянется в фоне")],
  },
  {
    id: "website-chat",
    name: t("Онлайн-чат на сайте"),
    description: t("Виджет на сайте: клиент пишет в чат, продавец отвечает из Hub."),
    category: "chat",
    icon: "ri-customer-service-2-line",
    connected: false,
    badge: t("Быстрый старт"),
    kind: "code",
    account: "",
    steps: [t("Скопируйте код виджета"), t("Вставьте его перед закрывающим тегом </body>"), t("Напишите в чат на сайте для проверки")],
  },
  {
    id: "webhook",
    name: t("Свой канал по API"),
    description: t("Любой сервис с вебхуками: заявки,CRM, маркетплейсы и внутренние системы."),
    category: "api",
    icon: "ri-plug-line",
    kind: "code",
    connected: false,
    account: "",
    steps: [t("Скопируйте адрес вебхука"), t("Настройте отправку событий у себя"), t("Проверьте входящее событие в журнале")],
  },
];